import { ProfessionAreaChartDirection as Direction } from 'src/models/pages/profession';

export const CHART_HEIGHT = 230;
export const SUCCESS_COLOR = '#0D8847'; // day/visualisation/line-2
export const ERROR_COLOR = '#D64030'; // day/visualisation/line-1
export const SUCCESS_GRADIENT_ID = `gradient-${Direction.MORE}`; // day/visualisation/fill-2
export const ERROR_GRADIENT_ID = `gradient-${Direction.LESS}`; // day/visualisation/fill-1
export const STROKE_COLOR = '#DCE3EB';
export const CHART_MARGIN = { top: 40, right: 16, bottom: 0, left: 0 };
export const ANIMATION_DURATION = 1000;
